"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _render = require("./render");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var content = (children, plugins, options) => _react.default.Children.map(children, child => typeof child === 'string' ? (0, _render.render)(child, plugins, options) : child);

var Component = (_ref) => {
  var {
    container,
    componentProps,
    children,
    plugins,
    options
  } = _ref;
  return _react.default.createElement(container, componentProps, content(children, plugins, options));
};

if (process.env.NODE_ENV !== 'production') {
  Component.propTypes = {
    container: _propTypes.default.node,
    children: _propTypes.default.node.isRequired,
    plugins: _propTypes.default.arrayOf(_propTypes.default.func),
    componentProps: _propTypes.default.shape({
      className: _propTypes.default.string
    }),
    options: _propTypes.default.shape({
      parser: _propTypes.default.func,
      skipParse: _propTypes.default.bool,
      onlyAllowTags: _propTypes.default.arrayOf(_propTypes.default.string),
      openTag: _propTypes.default.string,
      closeTag: _propTypes.default.string
    })
  };
}

Component.defaultProps = {
  container: 'span',
  plugins: [],
  options: {},
  componentProps: {}
};
var _default = Component;
exports.default = _default;